// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"efc0e70b","363":"2f5fab5d","453":"f09d260d","455":"c39991fd","487":"99b6f3f4","611":"f8c43997","660":"9479db6b","760":"387f51c5"}[chunkId] + ".chunk.js";
};